import React from 'react';
import { 
  Box, 
  TextField, 
  MenuItem, 
  Grid, 
  InputAdornment,
  Divider,
  useTheme,
  styled,
  Typography  // Added this import
} from '@mui/material';
import { Search, Sort, FilterList } from '@mui/icons-material';

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
  },
  '& .MuiInputLabel-root': {
    color: theme.palette.text.secondary,
  },
}));

const RedirectionFilters = ({ filters, onFilterChange }) => {
  const theme = useTheme();

  const handleChange = (e) => {
    onFilterChange({ [e.target.name]: e.target.value });
  };

  return (
    <Box 
      sx={{ 
        p: 3, 
        mb: 3, 
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.default,
        boxShadow: theme.shadows[1]
      }}
    >
      <Box 
        display="flex" 
        alignItems="center" 
        mb={2}
        color={theme.palette.text.secondary}
      >
        <FilterList sx={{ mr: 1 }} />
        <Typography variant="h6" component="h2">
          Filter Redirections
        </Typography>
      </Box>
      
      <Divider sx={{ mb: 3 }} />
      
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <StyledTextField
            fullWidth
            name="search"
            label="Search"
            placeholder="Source or destination"
            value={filters.search}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search color="action" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <StyledTextField
            fullWidth
            select
            name="match_type"
            label="Match Type"
            value={filters.match_type}
            onChange={handleChange}
          >
            <MenuItem value="">
              <em>All types</em>
            </MenuItem>
            <MenuItem value="exact">
              <Box>
                <Typography>Exact</Typography>
                <Typography variant="caption" color="text.secondary">
                  Full URL match
                </Typography>
              </Box>
            </MenuItem>
            <MenuItem value="startsWith">
              <Box>
                <Typography>Starts With</Typography>
                <Typography variant="caption" color="text.secondary">
                  Path prefix
                </Typography>
              </Box>
            </MenuItem>
            <MenuItem value="regex">
              <Box>
                <Typography>Regex</Typography>
                <Typography variant="caption" color="text.secondary">
                  Pattern match
                </Typography>
              </Box>
            </MenuItem>
          </StyledTextField>
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <StyledTextField
            fullWidth
            select
            name="redirect_type"
            label="Redirect Type"
            value={filters.redirect_type}
            onChange={handleChange}
          >
            <MenuItem value="">
              <em>All types</em>
            </MenuItem>
            <MenuItem value="301">
              <Box>
                <Typography>301</Typography>
                <Typography variant="caption" color="text.secondary">
                  Permanent
                </Typography>
              </Box>
            </MenuItem>
            <MenuItem value="302">
              <Box>
                <Typography>302</Typography>
                <Typography variant="caption" color="text.secondary">
                  Temporary
                </Typography>
              </Box>
            </MenuItem>
          </StyledTextField>
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <StyledTextField
            fullWidth
            select
            name="status"
            label="Status"
            value={filters.status}
            onChange={handleChange}
          >
            <MenuItem value="">
              <em>All statuses</em>
            </MenuItem>
            <MenuItem value="active">
              <Box display="flex" alignItems="center">
                <Box 
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    backgroundColor: theme.palette.success.main,
                    mr: 1
                  }} 
                />
                <Typography>Active</Typography>
              </Box>
            </MenuItem>
            <MenuItem value="inactive">
              <Box display="flex" alignItems="center">
                <Box 
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    backgroundColor: theme.palette.error.main,
                    mr: 1
                  }} 
                />
                <Typography>Inactive</Typography>
              </Box>
            </MenuItem>
          </StyledTextField>
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <StyledTextField
            fullWidth
            name="category"
            label="Category"
            placeholder="e.g. SEO, Campaign"
            value={filters.category}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={6} sm={3} md={2}>
          <StyledTextField
            fullWidth
            select
            name="sort"
            label="Sort By"
            value={filters.sort}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Sort fontSize="small" color="action" />
                </InputAdornment>
              ),
            }}
          >
            <MenuItem value="createdAt">Created</MenuItem>
            <MenuItem value="updatedAt">Updated</MenuItem>
            <MenuItem value="source">Source</MenuItem>
            <MenuItem value="destination">Destination</MenuItem>
          </StyledTextField>
        </Grid>

        <Grid item xs={6} sm={3} md={2}>
          <StyledTextField
            fullWidth
            select
            name="order"
            label="Order"
            value={filters.order}
            onChange={handleChange}
          >
            <MenuItem value="DESC">Descending</MenuItem>
            <MenuItem value="ASC">Ascending</MenuItem>
          </StyledTextField>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RedirectionFilters; 